import { useMamapediaCategoriesStore } from "@/stores/useMamapediaCategoriesStore";
import { getMamapediaCategories as fetchMamapediaCategories } from '@/lib/Definitions';
import { useEffect, useState, useRef } from "react";
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from "next/router";
import MamapediaMobileMenuItem from "./MamapediaMobileMenuItem";
import MamapediaDesktopMenuItem from "./MamapediaDesktopMenuItem";
import TopBanner from "./TopBanner";


const MamapediaHeader = () => {
  const router = useRouter();
  const categoriesData = useMamapediaCategoriesStore(state => state.mamapediaCategories);
  const updateMamapediaCategories = useMamapediaCategoriesStore(state => state.updateMamapediaCategories);
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  }

  useEffect(() => {
    isOpen ? (document.body.style.overflow = 'hidden') : (document.body.style.removeProperty('overflow'));
  }, [isOpen])

  const isSyncingRef = useRef(false);
  useEffect(() => {
    if ((categoriesData.data.length === 0 || categoriesData.update_date === null || categoriesData.update_date < Date.now() - 600000) && !isSyncingRef.current) {
      isSyncingRef.current = true;
      fetchMamapediaCategories()
        .then((resp) => {
          const newCategoriesData = {
            data: resp,
            update_date: Date.now()
          }
          updateMamapediaCategories(newCategoriesData);
        }).finally(() => {
          isSyncingRef.current = false;
        });
    }
  }, [categoriesData, updateMamapediaCategories])

  return (
    <nav id="menu" className="sticky z-[50] top-0 bg-white shadow-lg">
      <TopBanner />
      <div className="container shadow-[0_0_8px_0_rgba(0,0,0,0.15)] md:hidden bg-mooimom">
        <div className="flex items-center justify-between max-h-[60px] py-4">
          <div className="">
            <Image
              src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icon/mamapedia-mb-new.png"}
              alt="MOOIMOM Mamapedia logo"
              quality={100}
              width={500}
              height={150}
              className="max-w-[140px]"
              onClick={() => router.push("/mamapedia-homepage")}
            />
          </div>
          <div className="">
            <Image
              src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icons/menu-white.png"}
              alt="menu icon"
              quality={100}
              width={24}
              height={24}
              className="min-w-[20px]"
              onClick={toggleMenu}
            />
          </div>
        </div>
        <div className={`fixed inset-0 bg-black opacity-50 ${isOpen ? 'block' : 'hidden'}`} onClick={toggleMenu}></div>
        <div
          className={`categories fixed w-[90%] z-[50] bg-white top-0 h-dscreen transition-transform ease-in-out duration-300 transform inset-y-0 -right-full ${isOpen ? "-translate-x-full" : "translate-x-0"}`}
        >
          <div className="container">
            <Image
              src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icons/close.png"}
              alt="close icon"
              width={16}
              height={16}
              quality={100}
              onClick={toggleMenu}
              className="my-6 cursor-pointer"
            />
          </div>
          <MamapediaMobileMenuItem categories={categoriesData.data} />
          <div className="py-4 z-[55] bottom-0 border-t border-sku left-0 right-0 fixed w-[90%]">
            <Link href={"/"}>
              <div className="container flex items-center py-2 space-x-[10px]">
                <Image
                  src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icons/back-icon.png"}
                  alt="back to MOOIMOM icon"
                  quality={100}
                  width={24}
                  height={24}
                  className=""
                />
                <p className="text-base font-bold text-mooimom font-poppins">Shop at MOOIMOM</p>
              </div>
            </Link>
          </div>
        </div>
      </div>
      <div className="container hidden grid-cols-12 md:grid">
        <div className="flex items-center col-span-2 py-2">
          <Link href="/mamapedia-homepage">
            <Image
              src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icon/mamapedia-logo-color.png"}
              alt="MOOIMOM Mamapedia logo"
              quality={100}
              width={500}
              height={150}
              className="max-w-[150px]"
            />
          </Link>
        </div>
        <div className="flex items-center justify-between col-span-8 pl-9">
          {categoriesData.data.map((category, index) => {
            return (
              category.subcategory.length > 0 && (
                <MamapediaDesktopMenuItem key={index} category={category} />
              )
            )
          })}
        </div>
        <div className="flex justify-end col-span-2 py-4">
          <button
            className="p-2 text-xs font-semibold text-white rounded-lg bg-mooimom font-poppins"
            onClick={() => router.push("/")}
          >
            Shop at MOOIMOM
          </button>
        </div>
      </div>
    </nav>
  )
}

export default MamapediaHeader
